// @core/api/endpoints/document/approve_clause.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ApproveClauseRequest,
  DocumentClauseResponse,
} from '../../../types/document';

const BASE_PATH = '/document';

/**
 * Approve clause
 * Transitions a clause from DRAFT or REVIEW to APPROVED and records approved_at.
 */
export async function ApproveClause(
  clause_id: string,
  data: ApproveClauseRequest,
  options?: RequestOptions
): Promise<DocumentClauseResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/clauses/:clause_id/approve`;
  requestPath = requestPath.replace(':clause_id', encodeURIComponent(clause_id));
  const requestOptions = options;
  return client.post<DocumentClauseResponse>(requestPath, data, requestOptions);
}
